import { useEffect } from "react";
import useValidation from "../../../../hooks/useValidation";
import { LiquidatorEntityType } from "../../../../static/types/creationCloture/liquidatorType";
import liquidatorEntityValidationScheme from "../../../../utils/validation/liquidatorEntityValidationScheme";
import FieldDescription from "../../../tools/FieldDescription";
import PostalCodeField from "../../../commonComponents/PostalCodeField";

type legalEntityProps = {
    checked: boolean,
    legalEntity: LiquidatorEntityType,
    changeLegalEntity: ( data: Partial<LiquidatorEntityType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function LiquidatorLegalEntity ({
    checked,
    legalEntity,
    changeLegalEntity,
    onValidationChange
}: legalEntityProps ) {

    const { errors, isValid } = useValidation( legalEntity, liquidatorEntityValidationScheme );

    useEffect( () => {
        onValidationChange( isValid )
    }, [ isValid, onValidationChange ])

    return(

        <div className = "mb-3 row">

            <div className = "mb-3 row">

                <label htmlFor = "denomination1" className = "col-sm-2 col-form-label required"> Dénomination  <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-4">
                    <input
                        className = { `description-input form-control ${ ( checked && errors.companyName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "companyName"
                        id = "companyName"
                        value = { legalEntity.companyName }
                        onChange = { event => changeLegalEntity({ companyName: event.target.value }) }
                    />
                    {  ( checked && errors.companyName ) && <div className="invalid-feedback"> { errors.companyName } </div> }
                    <FieldDescription description = "Nom de la société, comme mentionné dans les statuts." />
                </div>

            </div>

            <div className = "mb-3 row">

                <label htmlFor = "address" className = "col-sm-2 col-form-label">Adresse <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-4">
                    <input
                        className = { `form-control ${ ( checked && errors.address ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "address"
                        id = "address"
                        value = { legalEntity.address }
                        onChange = { event => changeLegalEntity({ address: event?.target.value}) }
                    />
                    {  ( checked && errors.address ) && <div className="invalid-feedback"> { errors.address } </div> }
                </div>

                <label htmlFor = "additionalAddress" className = "col-sm-2 col-form-label">Adresse suite </label>

                <div className = "col-sm-4">
                    <input
                        className = "form-control"
                        type = "text"
                        name = "additionalAddress"
                        id = "additionalAddress"
                        value = { legalEntity.additionalAddress }
                        onChange = { event => changeLegalEntity({ additionalAddress: event.target.value }) }
                    />
                </div>

            </div>

            <div className = "mb-3 row">

                <PostalCodeField
                    checked = { checked }
                    onChange = { changeLegalEntity }
                    postalCode = { legalEntity.postalCode }
                    errors = { errors }
                />

                <label htmlFor = "city" className = "col-sm-2 col-form-label"> Ville <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-4">
                    <select
                        className = { `form-control ${ ( checked && errors.city ) ? 'is-invalid' : ''}` }
                        name = "city"
                        id = "city"
                        onChange = { event => changeLegalEntity({ city: event.target.value }) }
                        value = { legalEntity.city }
                    >
                        {
                            legalEntity.cities?.map( (city, key) => 
                                <option key = { key } value = { city }>
                                    { city }
                                </option>
                            )
                        }
                    </select>
                    {  ( checked && errors.city ) && <div className="invalid-feedback"> { errors.city } </div> }
                </div>
            </div>
        </div>
    )
}